import { useParams } from "react-router-dom";
import SalesVoucherPrint from "./SalesVoucher/components/SalesVoucherPrint";
import SalesReturnPrint from "./SalesReturnVoucher/components/SalesReturnPrint";
import PurchasePrint from "./Purchase/Purchase/PurchaseVoucher/components/PurchasePrint"
import PurchaseReturnPrint from "./Purchase/Purchase Return/PurchaseReturnVoucher/components/PurchaseReturnPrint"
import SalesOrderPrint from "./Order/Sales Order/SalesOrderVoucher/components/SalesOrderPrint";
import PurchaseOrderPrint from "./Order/Purchase Order/PurchaseOrderVoucher/components/PurchaseOrderPrint";
import ServicePrint from "./Service/Service/ServiceVoucher/components/ServicePrint";
import ServiceExpensePrint from "./Service/Service Expense/ServiceExpenseVoucher/ServiceExpensePrint";
import ManufacturingPrint from "./Manufacturing/ManufacturingVoucher/components/ManufacturingPrint";
// import ReceiptPrint from "../accounts/print/ReceiptPrint";

export default function PrintRenderer() {
  const { docType, id } = useParams();

  switch (docType) {
    case "sales":
      return <SalesVoucherPrint id={id} />;

    case "sales-return":
      return <SalesReturnPrint id={id} />;

    case "purchase":
      return <PurchasePrint id={id} />;

    case "purchase-return":
      return <PurchaseReturnPrint id={id} />;
    
      case "purchase-order":
      return <PurchaseOrderPrint id={id} />;
    
      case "sales-order":
      return <SalesOrderPrint id={id} />;

      case "service":
      return <ServicePrint id={id} />;
      
      case "service-expense":
      return <ServiceExpensePrint id={id} />;

      case "manufacturing":
      return <ManufacturingPrint id={id} />;

    // case "receipt":
    //   return <ReceiptPrint id={id} />;

    default:
      return <div>Invalid document</div>;
  }
}
